// src/pages/PurchaseRecord/purchaseRecordSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchPurchaseRecord ,deletePurchase} from "./PurchaseRecordThunks";

const initialState = {
  list: [],
  details: [],
  loading: false,
  error: null,
  printMode: false,
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
    supplierId: null,
    employeeId: null,
    itemId: null,
    groupId: null,
    categoryId: null,
    userId: null,
    locationId: null,
    tag_groupnameid: null,
    tagFeildNameid: null,
    voucherNo: null,
    invoiceNo: null,
    serialNumber: null,
  },
};

const purchaseRecordSlice = createSlice({
  name: "purchaseRecord",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetFilters(state) {
      state.filters = initialState.filters;
    },
    setPrintMode(state, action) {
      state.printMode = action.payload;
    },
    setList(state, action) {
      state.list = action.payload || [];
    },
    setDetails(state, action) {
      state.details = action.payload || [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchPurchaseRecord.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPurchaseRecord.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchPurchaseRecord.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(deletePurchase.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletePurchase.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deletePurchase.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setFilters, resetFilters, setPrintMode, setList, setDetails } = purchaseRecordSlice.actions;
export default purchaseRecordSlice.reducer;

export const selectPurchaseList = (state) => state.purchaseRecord.list;
export const selectPurchaseDetails = (state) => state.purchaseRecord.details;
export const selectPurchaseFilters = (state) => state.purchaseRecord.filters;
export const selectPurchaseLoading = (state) => state.purchaseRecord.loading;
